import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { http_get } from "utils/axios";

const initialState = { tesList: [], tesDetail: [], tangkapanKamera: [] };

export const tesList = createAsyncThunk(
  "tes/list",
  async (data, { rejectWithValue }) => {
    try {
      return await http_get(
        `industry/get-skor-talent?tipe=Education`,
        true,
        data
      );
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

export const tesDetail = createAsyncThunk(
  "tes/detail",
  async (data, { rejectWithValue }) => {
    try {
      return await http_get(
        `education/siswa/detail-skor?id_sesi_user=${data.id_sesi_user}&id_kategori=${data.id_kategori}`,
        true,
        data
      );
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

const tesReducer = createSlice({
  name: "tes",
  initialState,
  reducers: {
    ADDTESDETAIL: (state, action) => {
      state.tesDetail = action.payload;
    },
    TANGKAPANKAMERA: (state, action) => {
      state.tangkapanKamera = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(tesList.fulfilled, (state, action) => {
      state.tesList = action.payload.data.data.skor;
    });
  },
});

export const { ADDTESDETAIL, TANGKAPANKAMERA } = tesReducer.actions;

export const selectTesList = (state) => state.tes.tesList;
export const selectTesDetail = (state) => state.tes.tesDetail;
export const selectTangkapanKamera = (state) => state.tes.tangkapanKamera;

export default tesReducer.reducer;
